<template>
  <div v-if="(sections || []).length > 0">
    <ul :class="isRoot ? 'section_nav' : 'subsections'" v-if="!isMobile">
      <li v-for="(section, index) in (sections || [])" :class="{ active: isActive(section.Id) }" :style="{ height: itemHeight(section.Id) }" :ref="'navList_' + section.Id" :key="index">
        <span :class="isRoot ? 'section-wrapper' : 'subsection-wrapper'" :title="section.Name" @click="navClick(section.Id)">
          <icon :icon="['far', 'check-circle']" v-if="isComplete(section.Id)" />
          <icon :icon="['far', 'circle']" v-else />
          <Localize :text="section.Name" />
        </span>
        <FormNavigation :sections="section.Subsections" :parentActive="parentActive || isActive(section.Id)" :isRoot="false" />
      </li>
    </ul>
  
    <div class="mobile_nav" v-if="isMobile">
      <div class="mobile-nav-row">
        <div v-for="(section, index) in (sections || [])" class="mobile_nav_col" :class="{ active: isActive(section.Id) }" :key="index" :title="section.MobileName || section.Name" @click="navClick(section.Id)">
          <div>
            <icon :icon="['far', 'check-circle']" v-if="isComplete(section.Id)" />
            <icon :icon="['far', 'circle']" v-else />
          </div>
        </div>
      </div>
      <div class="mobile-nav-row">
        <div v-for="(section, index) in (sections || [])" class="mobile_nav_col" :class="{ active: isActive(section.Id) }" :key="index" :title="section.MobileName || section.Name" @click="navClick(section.Id)">
          <div>
            <Localize :text="section.MobileName || section.Name" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Localize from '@/components/Localize.vue'

export default {
  name: 'FormNavigation',
  components: {
    Localize
  },
  props: {
    sections: Array,
    parentActive: Boolean,
    isRoot: Boolean,
    isMobile: Boolean
  },
  data: () => {
    return {
      nativeHeight: 0,
      loaded: false
    }
  },
  computed: {

  },
  methods: {
    isActive: function (id) {
      return this.$store.getters.isNavActive(id)
    },
    isComplete: function (id) {
      return this.$store.getters.isSectionValid(id)
    },
    itemHeight: function (id) {
      if (!this.loaded)
        return

      if (this.parentActive || this.isActive(id)) {
        for (var i = 0; i < this.sections.length; i++)
          if (this.sections[i].Id === id)
            return this.sections[i].nativeHeight + 'px'
      }

      return '0px'
    },
    navClick: function (id) {
      this.$store.dispatch('navGo', id)
    },
    initDesktopMenu: function () {
      var vm = this

      if (window.innerWidth < 992)
        return

      if (vm.loaded)
        return

      // Don't run unless refs are loaded
      // nextTick apparently isn't strong enough to prevent errors, so check refs directly instead
      if (Object.keys(vm.$refs).length < (vm.sections || []).length) {
        setTimeout(function () {
          vm.initDesktopMenu()
        }, 5)
        return
      }

      // Calculate initial height of nav
      // nextTick so that things have rendered and the refs exist
      //this.$nextTick(function () {
        for (var i = 0; i < (vm.sections || []).length; i++) {
          var ref = vm.$refs['navList_' + vm.sections[i].Id][0]

          vm.sections[i].nativeHeight = ref.clientHeight
          if (vm.isRoot)
            vm.sections[i].nativeHeight = 55

          vm.sections[i].nativeHeight += (ref.querySelector('ul') || {}).clientHeight || 0
        }

        vm.loaded = true
      //})
    }
  },
  mounted: function () {
    window.addEventListener("resize", this.initDesktopMenu)
    this.initDesktopMenu()
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.initDesktopMenu)
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

ul.section_nav {
  border-radius: 3px;
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
  > li {
    height: 0px;
    min-height: calc(24px + 1.5em);
    overflow: hidden;
    padding: 12px 0 12px 12px;
    line-height: 1.5em;
    transition: height 0.2s;
    cursor: pointer;
    &:first-child {
      min-height: calc(32px + 1.5em);
      padding-top: 20px;
    }
    &:last-child {
      min-height: calc(32px + 1.5em);
      padding-bottom: 20px;
    }
    &.active {
      transition: height 0.4s;
      transition-delay: 0.2s;
      background-color: $lighter-gray;
      .section-wrapper {
        color: $primary;
      }

      ul.subsections {
        > li {
          &:after {
            position: absolute;
            top: -20%;
            left: 0;
            height: 100%;
            content: '';
            width: 12px;
            border-left: solid 1px $medium-gray;
            border-bottom: solid 1px $medium-gray;
          }
        }
      }
    }

    .section-wrapper {
      width: 100%;
      display: inline-block;
      padding: 12px 0;
      margin: -12px 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .svg-inline--fa {
      position: relative;
      top: -2px;
      font-size: 1.5em;
      margin-right: 10px;
      vertical-align: middle;
      color: $body-font-color;
      &.fa-check-circle {
        color: $primary;
      }
    }
    ul.subsections {
      position: relative;
      list-style: none;
      padding: 5px 0 0 30px;
      margin: 0;
      > li {
        position: relative;
        padding: 18px 0 0 20px;
        &.active {
          color: $primary;
        }
        //&:after {
        //  position: absolute;
        //  top: -20%;
        //  left: 0;
        //  height: 100%;
        //  content: '';
        //  width: 12px;
        //  border-left: solid 1px $medium-gray;
        //  border-bottom: solid 1px $medium-gray;
        //}
        &:first-child {
          padding: 10px 0 0 20px;
        }
      }
    }
  }
}

.mobile_nav {
  border-radius: 3px;
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 65px;
  font-size: 12px;

  .mobile-nav-row {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .mobile_nav_col {
      flex-basis: 0;
      flex-grow: 1;
      border-left: 1px solid #d8dada;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      :first-child {
        border-left: none;
      }

      svg {
        font-size: 1.5em;
        margin-top: 8px;
      }

      &.active {
        background-color: $lighter-gray;
        color: $primary;
      }
    }

     +.mobile-nav-row {
      flex-grow: 1;
    }
  }
}
</style>
